import { extendTheme } from "@chakra-ui/react";

const theme = extendTheme({
  fonts: {
    heading: `'Cormorant', sans-serif`,
    body: `'Amiko', sans-serif`,
  },
});

export default theme;
